import Sidebar from '../components/Sidebar.jsx';
import PageHeader from '../components/PageHeader.jsx';
import '../styles/fonts.css';
import Timeline from '../components/Timeline.js';
import ProfileView from '../components/ProfileView.jsx';

const IHP = () => {
	let IHPpic = 'https://static.igem.wiki/teams/5066/global/bgpic.png';
	let IHP1 = 'https://static.igem.wiki/teams/5066/human-practice/ihp1.png';
	let IHP2 = 'https://static.igem.wiki/teams/5066/human-practice/ihp2.png';
	let IHP3 = 'https://static.igem.wiki/teams/5066/human-practice/ihp3.png';
	let IHP4 = 'https://static.igem.wiki/teams/5066/human-practice/ihp4.png';
	let IHP7 = 'https://static.igem.wiki/teams/5066/human-practice/ihp7.png';
	let IHP8 = 'https://static.igem.wiki/teams/5066/human-practice/ihp8.png';
	let IHP9 = 'https://static.igem.wiki/teams/5066/human-practice/ihp9.png';
	let logo = 'https://static.igem.wiki/teams/5066/global/i2024-logo.webp';

	let sections = [
		{ id: 's1', name: 'Overview' },
		{ id: 's2', name: 'Public Engagement' },
		{ id: 's3', name: 'Expert Engagement' },
		{ id: 's4', name: 'Define the project ' },
		{ id: 's5', name: 'Idea Verification' },
		{ id: 's6', name: 'Real Field Implementation' },
		{ id: 's7', name: 'Social Implementation' },
		{ id: 's8', name: 'Conclusion of IHP' },
	];

	return (
		<div className='bg-[#fffae6]'>
			<PageHeader
				img={IHPpic}
				title='Integrated&nbsp;Human&nbsp;Practice'
				customPicture={
					<img
						src={'https://static.igem.wiki/teams/5066/cover/hp.gif'}
						alt='Custom'
						className='w-44 h-44'
					/>
				}
			/>

			<div className='flex bg-gradient-to-b from-[#fffae6] via-[#feedfb] to-[#d9eaf0]'>
				<Sidebar sections={sections} />

				{/* Main Content */}
				<div className='flex-col w-full p-[5px] md:p-[50px] my-[10px] mx-[5px] space-y-16 rounded-2xl bg-[#fffdf2] shadow-[-2px_4px_8px_-2px_rgba(0,0,0,0.2)]'>
					<div className='pb-12'>
						<section id='s1'>
							<div className='absolute -left-24  bg-[#C94C67] w-20 h-7 shadow-md'>
								<span className='text-gray-800 font-bold'></span>
							</div>
							<h2 className='text-3xl font-bold text-[#C94C67]'>
								Overview
							</h2>
							<div className='mt-4'>
								<p className='mt-4 text-gray-700'></p>
								<p className='mt-2 text-gray-700'>
									The primary aim of our Integrated Human
									Practices revolves around incorporating
									feedback from interviews with experts, data
									from public surveys, and knowledge from
									active engagement in relevant current
									events. We passed out a questionnaire to
									determine how much the public knows about
									dengue so that we could have a better
									insight into designing the educational
									activities. We also held a lot of interviews
									with experts, their critical views and
									feedback helped us to enhance different
									aspects of our project into one that is more
									effective, feasible, and likely to be
									successful.
								</p>
							</div>
						</section>
					</div>

					<div className='pb-12'>
						<section id='s2'>
							<h2 className='text-3xl font-bold text-[#C94C67]'>
								Public Engagement
							</h2>
							<br></br>
							<p className='mt-2 text-gray-700 font-bold'>
								Purpose
							</p>
							<p className='mt-2 text-gray-700'>
								To enhance our project's impact and secure
								broader recognition and support, we developed a
								comprehensive questionnaire aimed at gathering
								public opinions and attitudes toward dengue
								fever. This feedback will be instrumental in
								refining our approach and ensuring that our
								project aligns with societal needs and
								expectations, ultimately contributing to more
								effective and widely supported solutions.
							</p>
							<p className='mt-2 text-gray-700 font-bold'>
								Designs of the Survey
							</p>
							<p className='mt-2 text-gray-700'>
								We conducted a survey targeting the general
								public of all age groups to promote dengue
								awareness and to determine the public’s level of
								knowledge and understanding of dengue. This
								survey serves as an indicator of how important
								and relevant our project is to Taiwan and the
								world. We divided the survey into knowledge,
								attitude, and practice because we wanted to test
								how much the public knows about dengue, how they
								will react to dengue fever, and what they will
								do to fight against dengue fever. These are some
								selected results that display the public’s lack
								of knowledge, actions, and a bright attitude
								towards dengue fever that need improvements:{' '}
							</p>
							<p className='mt-2 text-gray-700 font-bold'>
								Key Findings from the Survey
							</p>
							<p className='mt-2 text-gray-700'>
								Our survey received 295 responses mostly from
								the mature adult(50-69), adult(30-49), and
								adolescent(12-17) age groups with most responses
								coming from residents in Taipei, New Taipei, and
								Hsinchu. Our survey revealed a significant gap
								in public knowledge regarding the
								identification, prevention, and severity of
								dengue fever. In response to these findings, we
								have tailored our educational initiatives to
								address these specific areas of need. By
								focusing on enhancing awareness and
								understanding, we aim to fill these knowledge
								gaps through targeted educational content and
								outreach efforts.{' '}
							</p>
							<p className='mt-2 text-gray-700'>
								Our goal is to empower the public with essential
								information and practical strategies for
								managing and preventing dengue fever, ultimately
								contributing to improved community health and
								greater public engagement with our project.{' '}
							</p>
							<br></br>
							<p className='mt-2 text-gray-700 font-bold'>
								Fig 1 - Public’s Knowledge of the Dengue Virus
								Carrier
							</p>
							<img src={IHP1} alt='ihp_img' className='p-8'></img>
							<br></br>
							<p className='mt-2 text-gray-700'>
								64.1% of 295 respondents said they were aware of
								the <span className='italic'>Aedes aegypti</span> mosquito being the carrier of
								dengue fever while 31.5% said they were not
								aware.
							</p>
							<p className='mt-2 text-gray-700'>
								To make it more known to people that <span className='italic'>Aedes aegypti </span>
								mosquitoes are the carriers of dengue
								fever we taught kindergarten children to
								distinguish different types of mosquitoes.{' '}
							</p>
							<br></br>
							<p className='mt-2 text-gray-700 font-bold'>
								Fig 2 - Public’s Confidence in their Ability to
								Identify Dengue Fever
							</p>
							<img src={IHP2} alt='ihp_img' className='p-8'></img>
							<p className='mt-2 text-gray-700'>
								On a scale of 1-5, 1 being not at all confident
								and 5 being extremely confident.
							</p>
							<p className='mt-2 text-gray-700'>
								Only 21% of the 295 responses are confident in
								their ability to identify the early signs and
								symptoms of dengue fever. Thus we focused on
								providing more information about identifying
								early signs and symptoms in our lessons. For
								instance, to increase public awareness of dengue
								fever symptoms, we organized a booth at the GEMS
								Academy on August 8th called Dengue Day. This
								initiative aimed to educate attendees about the
								most prevalent symptoms associated with dengue
								fever, providing them with critical information
								to recognize and respond to the disease
								effectively.{' '}
							</p>
							<p className='mt-2 text-gray-700 font-bold'>
								Fig 3 - Public’s Level of Participation in
								Dengue Fever Prevention
							</p>
							<img src={IHP3} alt='ihp_img' className='p-8'></img>
							<p className='mt-2 text-gray-700'>
								On a scale of 1-5, 1 being have not participated
								at all and 5 being have participated
								extensively.
							</p>
							<p className='mt-2 text-gray-700'>
								The survey revealed that approximately 70% of
								the 295 respondents had minimal to no
								involvement in community clean-up efforts or
								awareness campaigns related to dengue fever
								prevention. To address this, we focused on
								raising awareness about the severity of dengue
								fever and made extensive outreach efforts to
								engage the public. By highlighting the critical
								nature of the disease and actively communicating
								the importance of community participation, we
								aimed to encourage greater involvement in
								preventive measures and initiatives.{' '}
							</p>
							<br></br>
							<p className='mt-2 text-gray-700'>
								For example, we organized Dengue Day to educate
								the public about dengue fever. During this
								event, we invited esteemed experts Professor
								Chen and Professor Tsai to share their knowledge
								and insights. Their presentations provided
								valuable information on dengue fever, enhancing
								the audience's understanding and awareness of
								the disease.{' '}
							</p>
							<br></br>
							<p className='mt-2 text-gray-700 font-bold'>
								Fig 4 - Public’s Opinion about the Severity of
								Dengue Fever
							</p>
							<img src={IHP4} alt='ihp_img' className='p-8'></img>
							<p className='mt-2 text-gray-700'>
								On a scale of 1-5, 1 being not at all serious
								and 5 being extremely serious.
							</p>
							<p className='mt-2 text-gray-700'>
								Only 38.6% of the 295 responses considered
								dengue fever a serious public health issue, but
								dengue fever is one of or is the most serious
								public health issue in Taiwan. To let the public
								know about the symptoms that dengue fever could
								bring, we held a booth in GEMS academy on
								8/8(Dengue Day) to educate people on the harms
								caused by dengue fever and how severe it was.{' '}
							</p>
							<br></br>
							<p className='mt-2 text-gray-700 font-bold'>
								Fig 5 and 6 - Public's Likeliness to Take Action
								against Dengue Fever
							</p>
							<img src={IHP7} alt='ihp_img' className='p-8'></img>
							<p className='mt-2 text-gray-700'>
								On a scale of 1-5, 1 being not at all willing
								and 5 being extremely willing.
							</p>
							<br></br>
							<img src={IHP8} alt='ihp_img' className='p-8'></img>
							<p className='mt-2 text-gray-700'>
								On a scale of 1-5, 1 being have not taken any
								actions and 5 being have taken all recommended
								actions.
							</p>
							<p className='mt-2 text-gray-700'>
								The majority(~75%) of the 295 responses were all
								willing to take action to control the spread of
								dengue fever but only around half (56%) have
								taken most or all recommended actions to prevent
								dengue. For example, in our elementary school
								plan, we held a quiz game after showing the kids
								a video about dengue. On our elementary lesson
								plan slides, we quizzed them about the 4 steps
								of the method to prevent dengue which are
								search, pour, clean, and scrub.
							</p>
							<br></br>
							<p className='mt-2 text-gray-700 font-bold'>
								Fig 7 - Gephi Model to Show Proof of Need for
								Education
							</p>
							<img src={IHP9} alt='ihp_img' className='p-8'></img>
							<p className='mt-2 text-gray-700'>
								The purpose of our Gephi model is to analyze the correlation between knowledge about dengue fever and the participants' willingness to actively prevent the spread of this disease. In this model, 'Y' represents participants who are willing to take action against dengue, while 'N' represents participants who are not willing to take action. The top row categorizes participants based on their dengue knowledge level: 'Novice' indicates little to no knowledge, 'Beginner' indicates some knowledge, 'Proficient' indicates a solid understanding, and 'Expert' indicates a deep knowledge of dengue. The thickness of the lines in the model represents the strength of the correlation between knowledge level and willingness to take action, with thicker lines indicating stronger connections. Our statistical analysis highlights the importance of knowledge when it comes to an individual’s willingness to actively participate in disease prevention activities.
							</p>
							<p className='pt-8 text-lg text-gray-700 font-bold'>
								Conclusion
							</p>
							<p className='mt-2 text-gray-700'>
								From the results of the survey, the importance
								and significance of education programs - that
								include people of all ages and communities are
								important factors in the prevention of dengue
								fever. Public engagement is essential in our
								fight against dengue fever because this task is
								not possible alone. Thus, knowledge about dengue
								fever is important for public engagement because
								adequate knowledge leads to proactive public
								action taken to prevent dengue. With this in
								mind, we chose to take on as many opportunities
								as we can to teach people of all ages and
								communities.
							</p>
						</section>
					</div>

					<br></br>

					<div className='pb-12'>
						<section id='s3'>
							<div className='absolute -left-24  bg-[#C94C67] w-20 h-7 shadow-md'>
								<span className='text-gray-800 font-bold'></span>
							</div>
							<h2 className='text-3xl font-bold text-[#C94C67]'>
								Expert Engagement
							</h2>
							<p className='mt-2 text-gray-700'>
								Our project’s stakeholder engagements start with expert consultation. Our expert consultation phase is split into four stages: defining the project, idea verification, real-field implementation, and social implementation. For the definition of the project phase, we interviewed two professors who are local experts in public health and infectious diseases. After that, we moved onto the idea verification phase, where we verified our idea with  experts in insect research, such as entomology and insecticide resistance, to learn more about dengue fever and its prevention, as well as an expert in biology who educated us about how to carry out the synthetic biology parts of the project. Moving on from that, we now enter the real-field implementation phase, where we gained valuable insights on how to model our business and form collaboration with companies from investors, bio entrepreneurs, and company representatives. Finally, to expand our implementation, we moved onto the social implementation phase, where we contacted experts who are involved in fields that require community and society engagement, then learned how to make our product attractive and eventually beneficial to those all in society.

							</p>
							<br></br>
							<div className=' p-4 mt-12 mb-32'>
								<img
									src={logo}
									alt='logo'
									className='w-36 h-auto'
								></img>
								<p className='pl-8'>Goal of IHP</p>
								<Timeline />
							</div>
							<p className='mt-2 text-gray-700'>
								Our project engaged with many experts from many
								different places around the world and gave us
								an idea of how other countries are dealing with
								dengue fever and how it is prevalent in other
								areas as well.{' '}
							</p>
							<img
								src='https://static.igem.wiki/teams/5066/human-practice/worldmap.png'
								alt='hp'
								className=''
							/>
							<p className='mt-2 text-gray-500'>
								Fig 8 - Destination of Outreach
							</p>

							<div className='pb-12'>
								<section id='s4'>
									<h1 className='text-2xl mt-8 font-bold text-[#C94C67]'>
										Define the Project
									</h1>
									<p className='mt-2 text-gray-500'>
										This is the initial phase of the project where
										we need to discover the problem we want to
										tackle and figure out a solution that we will
										want to commit to.To find inspiration and
										guidance, we turned to experts in the field we
										wanted to research more about.
									</p>
									<div className='p-[5px] md:p-[50px]'>
										<ProfileView
											name={
												'Professor Emeritus Dr. Jin-Sheng Chen (Chang Jung Christian University  & Chief Consultant, National Mosquito-Borne Diseases Control Research Centre) '
											}
											img={
												'https://static.igem.wiki/teams/5066/human-practice/profchen.png'
											}
											date={'2024/07/02'}
											intro={
												'The purpose of the interview with Professor Dr. Chen, a chief epidemic prevention advisor at the National Mosquito Vector Center, was to present the project idea and gather insights on the technical aspects and direction of the research. Our team sought his expertise to refine our research plan and address challenges we faced. Our team also met with Professor Chen before the final selection of our topic. He emphasized vector control and gave us suggestions on how we should test the effectiveness of our recombinant proteins and sticky ovitrap. Dr. Chen was very encouraging and supportive throughout our project, playing an essential role in guiding our research direction.'}
										>
											<img
												src='https://static.igem.wiki/teams/5066/human-practice/meet1.png'
												className='p-8'
												alt='meetPic'
											/>

											<p className='p-[5px] md:p-[25px] mt-2 text-gray-700 font-bold'>
												Key Insights and Takeaways
											</p>
											<ul className='pb-8 list-disc mx-8'>
												<li>
													Emphasized the importance of continuous vector control research in combating arthropod-borne diseases such as dengue, Zika, and malaria.
												</li>
												<li>
													Provided valuable feedback on testing the effectiveness of recombinant proteins and sticky ovitraps.
												</li>
												<li>
													Suggested various bioassays to validate our concepts and prove the toxicity of recombinant biolarvicides.
												</li>
											</ul>
										</ProfileView>
									</div>
									<div className='p-[5px] md:p-[50px]'>
										<ProfileView
											name={'Professor Dr. Kun-Hsien Tsai (Professor & Associate Dean of College of Public Health, National Taiwan University)'}
											img={
												'https://static.igem.wiki/teams/5066/human-practice/prof-tsai.jpg'
											}
											date={'2024/07/02'}
											intro={
												'In this interview, our team presented the project idea to Dr. Tsai, an associate professor at the Institute of Environmental and Occupational Health Sciences / Department of Public Health, and consulted for their opinion on the technicality and direction of the research. Our team presented our research plan, aspirations, and challenges during this interview. We consulted him on the project technicality and gathered feedback on our research aspirations. His perspective was crucial for understanding the broader implications of our work in public health. He provided us with valuable feedback, mainly about medical entomology research, and synthetic biology in Taiwan and its future, and gave us tips on conducting proper research.'}
										>
											<img
												src='https://static.igem.wiki/teams/5066/human-practice/meet2.png'
												className='p-8'
												alt='meetPic'
											/>
											<p className='p-[5px] md:p-[25px] mt-2 text-gray-700 font-bold'>
												Key Insights and Takeaways
											</p>
											<ul className='pb-8 list-disc mx-8'>
												<li>
													Advised on effective research design, emphasizing the need to compare experimental and control groups for unbiased data collection.</li>
												<li>
													Recommended setting clear variables and constants for our experiments to enhance reliability.
												</li>
												<li>
													Offered insights into different methodologies for assessing the impact of our interventions on public health.</li>
											</ul>
										</ProfileView>
                                        <p className='mt-10 font-bold text-gray-700 leading-relaxed'>
                                                Summary                               
                                            </p>
                                            <p className='mt-1 text-gray-700 leading-relaxed'>
                                            The interviews with Professor Chen and Professor Tsai helped refine our project’s focus and research design. Professor Chen emphasized the importance of vector control and suggested methods to test the effectiveness of our recombinant proteins and sticky ovitraps. Professor Tsai provided guidance on effective research design, including comparing experimental and control groups and ensuring reliability through clear variables. Their insights were crucial in shaping a scientifically sound and impactful research plan.
                                </p>
									</div>

								</section>
							</div>
                    
							<div className='pb-12'>
								<section id='s5'>
									<h1 className='text-2xl mt-1 font-bold text-[#C94C67]'>
										Idea Verification
									</h1>
									
									<p className='mt-5 text-gray-700'>
										Following the definition of the project phase,
										we need to carry out our project and verify our
										ideas with experts who can give good insights
										and critiques that can improve and make our
										project the best it can be.
									</p>
									<div className='p-[5px] md:p-[50px]'>
										<ProfileView
											name={
												'Dr. Chee-Dhang, Chen, Institute of Biological Sciences, University of Malaya'
											}
											date={'2024/07/05'}
											img={
												'https://static.igem.wiki/teams/5066/human-practice/oridr-chen-chee-1656303285.webp'
											}
											intro={
												'Dr. Chee-Dhang Chen spent over a decade researching and understanding the highly specialized field of medial and forensic entomology. Currently, he is working at the Institute of Biological Sciences, Universiti of Malaya. Dr. Chen has published numerous publications on ovitrap surveillance and public knowledge, attitude, and practice of dengue prevention, awareness, and participation. In this particular interview, hosted online, we interviewed Dr. Chen about insectology, insecticide resistance, mosquito bionomics, and public awareness of mosquito-borne diseases.'
											}
										>
                                            <div className='mt-5 flex justify-center items-center'>
												<img
													src='https://static.igem.wiki/teams/5066/human-practice/dr-chen.png'
													className='w-[700px] h-auto'
													alt='meetPic'
												/>
											</div>
                                           
											<p className='p-[5px] md:p-[25px] mt-2 text-gray-700 font-bold'>
												Key Insights and Takeaways
											</p>
											<div className='px-4'>
												<p className='mt-2 text-gray-700 '>
													1. Functionality: Our team would
													incorporate sticky paper into our
													ovitraps to enhance the function of
													our traps.Dr.Chen expresses that
													if our trap catches one female
													mosquito, then it is the equivalent
													of catching 200 more mosquitoes
													because it can lay 200 eggs.Dr.
													Chen provided insights on how our
													team should modify our ovitrap to
													lead to more success in capturing
													mosquitoes.Proceeding with our plan
													to develop a design for our ovitrap,
													we decided to keep our initial
													design by still incorporating sticky
													paper in the interior wall of the
													trap as it increases the
													effectiveness of the trap.
												</p>
												<p className='mt-2 text-gray-700 '>
													2. Experimental trials: Other than
													crafting an ovitrap, he suggests
													that our team has to conclude when
													the users should change the water
													and pellets of the trap, and we also
													have to find statistical proof of
													how our product is more effective in
													catching mosquitoes than other traps
													on the market.
												</p>
												<p className='mt-2 text-gray-700 '>
													3. Labeling: He also talks about the
													importance of having a clear
													instruction manual with pictures for
													the users.Furthermore, he expressed
													the importance of emphasizing the
													non-toxic aspect of our ovitrap
													because that is one of the main
													concerns people might have doubts
													about when synthetic biology is
													implemented.Doing so may relieve
													concerns of the users on the
													toxicity and user safety of the
													ovitrap.
												</p>
											</div>
										</ProfileView>

									</div>
									<div className='p-[5px] md:p-[50px]'>
										<ProfileView
											name={
												'Associate Professor. Dr. Low Van Lun, Universiti Malaya'
											}
											img={
												'https://static.igem.wiki/teams/5066/human-practice/dr-low-van-lun.jpeg'
											}
											date={'2024/07/18'}
											intro={
												'Associate Professor Dr. Van-Lun Low specializes in dengue, vector control, insecticide resistance, and tropical medicine. He has published extensively on insecticide resistance and was recognized and appointed by the Ministry of Health, Malaysia as a member of the Technical Working Committee for Insecticide Resistance. In addition, he also provides mitigation plans against insecticide resistance issues in Malaysia. Since our project aims to synthesize recombinant biolarvicidal proteins, we sought his opinion on the practicality, overall research design, and execution of this project. Since our project aims to synthesize recombinant biolarvicidal proteins, we sought his opinion on the practicality, overall research design, and execution of this project.'
											}
										>
                                             <div className='mt-5 flex justify-center items-center'>
												<img
													src='https://static.igem.wiki/teams/5066/human-practice/dr-chen.png'
													className='w-[700px] h-auto'
													alt='meetPic'
												/>
											</div>
											<p className='p-[3px] md:p-[20px] mt-2 text-gray-700 font-bold'>
												Key Insights and Takeaways
											</p>
											<p className='md:p-[25px] text-gray-700'>
												Associate Professor Dr.Low emphasized
												the importance of our project's
												cost-effectiveness, communication, and
												biosafety of our biolarvicidal proteins.
												He also suggested we could conduct WHO
												standard oviposition assays, such as
												using different concentrations of
												beetroot peel powder and recombinant
												toxins.We also discussed the biosafety
												issues of recombinant biolarvicidal
												proteins being applied in the real
												field.We learned that we must
												synthesize the recombinant proteins and
												undergo robust tests in vitro and in
												vivo.
											</p>
										</ProfileView>
									</div>

									<div className='p-[5px] md:p-[50px]'>
										<ProfileView
											name={'Professor Dr. Stanley Norman Cohen'}
											img={
												'https://static.igem.wiki/teams/5066/human-practice/profcohen.png'
											}
											date={'2024/07/11'}
											intro={
												'Professor Stanley Cohen and his partner, Professor Dr. Herbert Wayne Boyer, at the University of California, San Francisco, were the first two scientists to clone DNA and transplant genes from one living organism to another. Their achievement laid the foundation and is often considered the birth of genetic engineering. In this interview, we asked him about his feedback and tips for our team on project conceptualization, especially on the larvicidal toxins in the chromosome-free system. They gave us valuable feedback, mainly about vector control, medical entomology research, and synthetic biology in Taiwan and its future, and they gave us tips on how we should test the effectiveness of our recombinant proteins and sticky ovitrap.'
											}
										>
											<img
												src='https://static.igem.wiki/teams/5066/human-practice/meet3.png'
												className='p-8'
												alt='meetPic'
											/>

											<p className='p-[5px] md:p-[25px] mt-2 text-gray-700 font-bold'>
												Key Insights and Takeaways
											</p>
											<p className='mx-4 text-gray-700 '>
												Our team asked Professor Cohen about the
												technical aspects of cloning and
												transformation.We started our
												experiment in June and were anxious when
												we could not get the sequence right
												after the transformation.Professor
												Cohen kindly troubleshooted the
												experiment procedures and encouraged us.
												He also shared cloning techniques and
												experiences with us.We also discussed
												the idea of using a chromosome-free
												system and the purpose of this in our
												project.Professor Cohen taught us a lot
												during this interview, and we were
												greatly inspired and thankful for the
												time he spent with us during this
												interview.{' '}
											</p>
										</ProfileView>
                                        <p className='mt-10 font-bold text-gray-700 leading-relaxed'>
                                                Summary                               
                                            </p>
                                            <p className='mt-1 text-gray-700 leading-relaxed'>
                                            The interviews with experts helped verify our project idea by providing practical guidance, technical feedback, and suggestions for improvement. Dr. Chee-Dhang Chen provided insights into mosquito trapping and suggested modifications to enhance our ovitrap's functionality, including statistical validation and emphasizing non-toxicity for user safety. Dr. Van-Lun Low highlighted the importance of cost-effectiveness, communication, and biosafety of our biolarvicidal proteins, suggesting WHO standard assays and emphasizing in vitro and in vivo testing. Professor Stanley Cohen offered technical advice on cloning and troubleshooting experiment procedures, helping us refine our approach to using a chromosome-free system. These insights collectively strengthened our project's feasibility and validity.
                                </p>
									</div>
								</section>
							</div>
							<div className='pb-12'>
								<section id='s6'>
									<h1 className='text-2xl mt-8 font-bold text-[#C94C67]'>
										Real Field Implementation
									</h1>
									<p className='mt-5 text-gray-700'>
										Following the idea verification phase, we need
										to find ways of implementing our product in the
										real world.To figure out how to insert our
										product into the market, we need advice from
										experts on business strategies and possibly
										future collaborations with other companies.{' '}
									</p>
									<div className='p-[5px] md:p-[50px]'>
										<ProfileView
											name={'WiAdvance'}
											img={
												'https://static.igem.wiki/teams/5066/human-practice/wiadvancenew.png'
											}
											date={'2024/08/07'}
											intro={
												'Based on Cloud, Data, and AI technology, WiAdvance is a subsidiary company of Wistron Corporation, which is headquartered in Taiwan. They are a premier Microsoft Gold Partner, MCPP partner, Licensing Solution Partner (LSP), and Cloud Solution Provider (CSP). We hoped to gain better insights and business strategy recommendations, regarding their AI Dengue Fever Prevention Platform. Our initial purpose was to discuss potential collaboration and learn more about their AI Dengue Fever Prevention Platform.'}
										>
											<img
												src='https://static.igem.wiki/teams/5066/software/swsample.png'
												className='p-8'
												alt='meetPic'
											/>

											<div className="max-w-4xl mx-auto p-6 bg-white shadow-lg">
												{/* Title */}
												
												<p className='p-[3px] md:p-[20px] mt-2 text-gray-700 font-bold'>
												Key Insights and Takeaways
												</p>

												<ul className="list-disc pl-5 mb-4 space-y-3">
													<li>
														WiAdvance’s project lasted for 1.5 years.It is a system that collects
														and stores data, and then uses AI to count mosquito eggs and detect
														whether the larva is an <span className='italic'>Aedes</span> mosquito.
													</li>
													<li>
														The more AI machine learning, the higher the accuracy.They reached an
														accuracy of 95%, through feeding the AI with millions of images taken
														by the public , helping to increase their accuracy.
													</li>
													<li>
														First to use AI to create a dengue fever prevention platform and
														distinguish larvae.
													</li>
													<li>Advice Regarding Our Project: </li>

												</ul>
												<ul className="pl-12 list-disc space-y-3">
													<li>
														Southeast Asia is a possible area we could look into
													</li>
													<li>
														Getting more pictures to help the accuracy of our photo detector
													</li>
													<li>
														Figure a way to encourage household users to buy our product
													</li>
													<li>
														Integration of AI is highly encouraged
													</li>
												</ul>
											</div>
										</ProfileView>
									</div>
									<div className='p-[5px] md:p-[50px]'>
										<ProfileView
											name={'John Cumbers, CEO, SynBioBeta'}
											img={
												'https://static.igem.wiki/teams/5066/human-practice/johncumbers.png'
											}
											date={'2024/07/06'}
											intro={
												'John Cumbers is a molecular biologist. He is also the founder and chief executive officer of SynBioBeta which promotes synthetic biology to build a more sustainable universe. The purpose of this interview was to get an initial idea of how to model our business and start our business plan. Additionally, we wanted to get the perspective and opinions of an expert bioentrepreneur to better adjust our project. '
											}
										>
											<div className='flex justify-center items-center'>
												<img
													src='https://static.igem.wiki/teams/5066/human-practice/synbiobeta.png'
													className='w-72 h-auto'
													alt='meetPic'
												/>
											</div>
											<img
												src='https://static.igem.wiki/teams/5066/human-practice/cohenimg1.png'
												className='p-8'
												alt='meetPic'
											/>
											<p className='p-[5px] md:p-[25px] mt-2 text-gray-700 font-bold'>
												Key Insights and Takeaways
											</p>
											<ul className='list-disc px-12'>
												<li>
													Could work with existing pest
													companies then we wouldn't need to
													go around - distribution channel
												</li>
												<li>
													A maintenance service - get paid to
													fix the ovitraps
												</li>
												<li>
													We charge for the subscription from
													the pest company → impact would be a
													lot larger
												</li>
												<li>
													Dive into a different market →
													camping industry
												</li>
												<li>
													Use the business model canvas → can
													do one for the customer and pest
													companies
												</li>
												<li>
													Need to collect the data and
													validate your assumptions to de-risk
													your company
												</li>
												<li>
													Ask some questions about mosquitos →
													to validate
												</li>
												<li>
													By working closely with existing
													pest control companies, we can
													streamline distribution and build a
													subscription-based service that will
													ensure ongoing support and product
													optimization
												</li>
												<li>
													Aim to validate our assumptions
													through data collection, further
													improving our business model and
													ensuring its success
												</li>
												<li>
													Expand our product offering into a
													comprehensive pest control service,
													providing not only the ovitraps but
													also regular maintenance and pest
													monitoring
												</li>
											</ul>
										</ProfileView>
									</div>
									<div className='p-[5px] md:p-[50px]'>
										<ProfileView
											name={
												'Ms. Yew-Ling Chan, General Manager, Fuakilla Malaysia Berhad'
											}
											img={
												'https://static.igem.wiki/teams/5066/human-practice/profgirl.png'
											}
											date={'2024/07/04'}
											intro={
												'Ms. Yew-Ling Chan is the General Manager of Research & Development at Fumakilla Malaysia Berhad, a multinational insecticide manufacturer. Ms. Chan and the team discussed multiple perspectives on the significance of the project: Ovitrap designs, vector control, marketing, and a customer-based mindset toward the product. Ms. Chan provided a valuable marketing point of view regarding the project and further developments. In addition, we also discussed the potential of our recombinant proteins being used as larvicides in the field to reduce cases.'
											}
                                            >
                                             <div className='mt-5 flex justify-center items-center'>
												<img
													src='https://static.igem.wiki/teams/5066/human-practice/yew-ling.png'
													className='w-[700px] h-auto'
													alt='meetPic'
												/>
											</div>
											<p className='p-[3px] md:p-[20px] mt-2 text-gray-700 font-bold'>
												Key Insights and Takeaways
											</p>
											<ul className='list-disc px-8 pb-8'>
												<li>
													Ms.Chan commented that for our
													product to be marketable and widely
													used by the public , we must design
													our synbio system with hardware to
													be user-friendly.We take heed of
													Ms.Chan's advice, and we have
													prepared the detailed instruction
													manual for Beeter Trap and a guide
													to use MosBeeter, our product for
													recombinant biolarvicidal proteins
													with beetroot peel powder.
												</li>
												<li>
													We also discussed the
													entrepreneurship plan and
													potentially marketing our synbio
													system with hardware to
													dengue-endemic countries.Ms.Chan
													shared with us the processes
													involved in the R&D of insecticides
													from bench to market.She suggested
													that we would need to properly
													conduct the biolarvicidal assay,
													register our compound with local
													regulatory bodies, market survey and
													educate the public or potential
													consumers to allow them to better
													understand our products..
												</li>
											</ul>
                                    
										</ProfileView>
									</div>

									<div className='p-[5px] md:p-[50px]'>
										<ProfileView
											name={
												'Mr. K. C. Kong, CEO, Cytomics Sdn. Bhd'
											}
											img={
												'https://static.igem.wiki/teams/5066/human-practice/kong.png'
											}
											date={'2024/07/05'}
											intro={
												'Mr. K.C. Kong is the CEO of Cytomics Sdn. Bhd, a Malaysian-based biotechnology company that offers a range of services on mass spectrometry, extracellular vesicle sample preparations, and protein assays. Mr. Kong is a bioentrepreneur, passionate in delivering quality and affordable research services in Malaysia. As we would like to further extend our knowledge into the business world and appeal our ovitraps to the general public, we asked Mr. Kong numerous questions regarding how to appeal to stakeholders to invest in our product, effective strategies promoting biotech products, and pest control in Taiwan.'
											}
										>
                                             <div className='mt-5 flex justify-center items-center'>
												<img
													src='https://static.igem.wiki/teams/5066/human-practice/mr-kong-1.png'
													className='w-[700px] h-auto'
													alt='meetPic'
												/>
											</div>
											<p className='p-[3px] md:p-[20px] mt-2 text-gray-700 font-bold'>
												Key Insights and Takeaways
											</p>
											<ul className='list-disc px-8 pb-8'>
												<li>
													To appeal to the stakeholders to
													persuade them to invest in our
													product, the most important part is
													to first identify the current
													problem and the demand for this
													problem.{' '}
												</li>
												<li>
													Affordability: From the perspectives
													of the stakeholders, the product
													should be affordable.With this
													being said, how our team reduces the
													cost of the product yet also
													enhances productivity
													simultaneously.After this meeting,
													we realized that our first step to
													convince stakeholders to fundraise
													and invest is to remodel our
													ovitrap, as Mr.Kong mentioned,
													before promoting our product to the
													public.{' '}
												</li>
												<li>
													Target audience: The perfect and
													most effective market strategy does
													not exist until our team penetrates
													the market.Our team can target
													third-world countries as our main
													source of audience as dengue fever
													is more commonly exposed.{' '}
												</li>
											</ul>
										</ProfileView>
									</div>

									<div className='p-[5px] md:p-[50px]'>
										<ProfileView
											name={'Dr. Ling Wong '}
											img={
												'https://static.igem.wiki/teams/5066/human-practice/profgirl2.png'
											}
											date={'2024/08/17'}
											intro={
												'Having a unique background and experience as a scientist, entrepreneur, and investor, Dr. Wong has been involved in some of the market’s most notable investments and exits including several $1B+ companies. We hoped to gain feedback from her to enhance our business model as well as seek hardware improvement advice to make it more attractive to customers. '
											}
										>
                                             <div className='mt-5 flex justify-center items-center'>
												<img
													src='https://static.igem.wiki/teams/5066/human-practice/dr-ling-wong.png'
													className='w-[700px] h-auto'
													alt='meetPic'
												/>
											</div>
											<p className='p-[3px] md:p-[20px] mt-2 text-gray-700 font-bold'>
												Key Insights and Takeaways
											</p>
											<ul className='list-decimal px-8 pb-8'>
												<li>
													Focus on making your product
													consumer-friendly.Public insight is
													extremely important as you need to
													consider sizing, aesthetics, and
													even the design of the instruction
													manual.
												</li>
												<li>
													For implementation and scaling up in
													developing countries, you need to
													ensure you have product market fit
												</li>
												<li>
													Further modify our instruction
													manual to be clearer
												</li>
												<li>
													Discuss further improvements to the
													appearance of our hardware
												</li>
												<li>Make it user-friendly</li>
											</ul>
										</ProfileView>
									</div>
									<p className=' mt-2 text-lg text-gray-700 font-bold'>
										Summary
									</p>
									<p className=' pt-4 text-gray-700'>
										The interviews conducted during the real field
										implementation phase provided essential guidance
										for integrating the sticky ovitrap project into
										the market.WiAdvance emphasized the value of AI
										integration for improved mosquito detection and
										counting, highlighting the need for public
										engagement strategies.John Cumbers suggested
										leveraging partnerships with existing pest
										control companies and adopting a
										subscription-based service for product
										distribution and maintenance, while encouraging
										data validation to de-risk the business.Ms.
										Chan focused on product usability, recommending
										a user-friendly design and adherence to
										regulatory standards in dengue-endemic regions.
										Mr.Kong stressed the importance of cost
										reduction and targeting stakeholders by
										demonstrating the product’s affordability and
										relevance in solving dengue-related issues.Dr.
										Wong highlighted consumer-focused design
										elements and scalability in developing
										countries.Thus we attempted at inegrating AI
										and adding in the entrepreneurship plan that
										pest control companies are potential partners
										and part of our vision of our company’s
										expansion.We also made sure to make our product
										user-friendly and market fit by adding a user
										manual that is detailed enough for anyone to
										understand and made our product affordable for
										all by coming up with the affordable alternative
										Pennytrap and initializing the first step to
										scalability in developing countries.We also
										mention dengue relevance to all to increase
										public engagement and to target stakeholders.
										These insights collectively shape a well-rounded
										strategy for effective market entry and business
										growth.
									</p>
								</section>
							</div>
							<div className='pb-12'>
								<section id='s7'>
									<h1 className='text-2xl mt-8 font-bold text-[#C94C67]'>
										Social Implementation
									</h1>
									<p className='mt-5 text-gray-700'>
										Following the real field implementation phase,
										we need to explore another way of implementation
										which is about slotting our product into
										society.Therefore, there is a need to learn
										from experts about how our product can play an
										important role in helping better societies’
										lives, especially in vulnerable areas, and how to
										make our product attractive to all.{' '}
									</p>
									<div className='p-[5px] md:p-[50px]'>
										<ProfileView
											name={
												'Professor Jason Wang, LCY: Tan Lan Lee Professor and Professor of Pediatrics (General Pediatrics) and of Health Policy, Stanford University'
											}
											img={
												'https://static.igem.wiki/teams/5066/human-practice/jason.png'
											}
											date={'2024/08/02'}
											intro={
												'Professor Jason Wang is the Director of the Center for Policy, Outcomes, and Prevention and he is interested in pandemic preparedness, assessing and improving the value of healthcare and healthcare delivery innovations, and payment reforms. He has vast experience in medical care, and we would like to ask him about the implementation and significance of our project in the global setting.'
											}
										>
                                                <div className='mt-5 flex justify-center items-center'>
												<img
													src='https://static.igem.wiki/teams/5066/human-practice/jason-wang.png'
													className='w-[700px] h-auto'
													alt='meetPic'
												/>
											</div>
											<p className='p-[3px] md:p-[20px] mt-2 text-gray-700 font-bold'>
												Key Insights and Takeaways
											</p>
											<p className='p-[3px] md:p-[20px] text-gray-700'>
												Prof.Jason mentioned that if we want to
												bring our project beyond Taiwan and
												benefit the world suffering from dengue,
												we must{' '}
												<strong>
													lower the production cost of our
													synbio and hardware system.{' '}
												</strong>
												He shared with us the course offered by
												Stanford Design for Extreme
												Affordability and asked us to explore
												and apply this concept to Dengue
												Beeters.We learned valuable insight
												from Prof.Wang, and we went and
												developed a Pennytrap that aims to allow
												wide application of our sticky gravid
												trap in underdeveloped and
												dengue-epidemic countries.{' '}
											</p>
										</ProfileView>
									</div>
									<div className='p-[5px] md:p-[50px]'>
										<ProfileView
											name={
												'Gonçalo Martins Alves, The MENTOR initiative'
											}
											img={
												'https://static.igem.wiki/teams/5066/human-practice/mentor.png'
											}
											date={'2024/08/02'}
											intro={
												'Mr. Gonçalo Martin Alves is a field entomologist working at The MENTOR Initiatives, a registered non-governmental organization that aims to save lives by implementing various tropical medicine controls and helping people in need recover from the crisis of tropical medicine. The MENTOR Initiatives works with malaria and dengue in countries such as Angola, Central African Republic, Mozambique, Nigeria, South Sudan, Syria, and Venezuela. Mr. Gonçalo is doing integrated vector management in dengue-affected countries, such as larvicidal and source reduction. As we also have the same ambition to implement our project beyond Taiwan, we seek his feedback on our Beeter trap. We are interested in learning and exploring whether Dengue Beeters is feasible to scale up and reach out to other organizations who are doing the greater good in vector control and disease control.'
											}
										>
                                             <div className='mt-5 flex justify-center items-center'>
												<img
													src='https://static.igem.wiki/teams/5066/human-practice/gon-alo.png'
													className='w-[700px] h-auto'
													alt='meetPic'
												/>
											</div>
											<p className='p-[3px] md:p-[20px] mt-2 text-gray-700 font-bold'>
												Key Insights and Takeaways
											</p>
											<ul className='list-disc px-8 pb-8 text-gray-700'>
												<li>
													Application: Mr.Gonçalo shared his
													experience with the real-field
													application of vector control in
													underdeveloped countries.He
													mentioned that we should make the
													material of our ovitraps
													eco-friendly.He pointed out that
													plastic has already proved to be a
													rather troublesome material, and it
													would not be ideal if we contribute
													to unnecessary plastic.At the very
													least, we have to make sure that our
													ovitraps are reusable and will last
													in the long run to prevent plastic
													waste.After listening to Mr.
													Gonçalo’s input, we stepped up our
													education to improve our
													transparency regarding synthetic
													biology.For example, we spread
													awareness about the benefits of
													synthetic biology in combating
													arthropod-borne diseases.We
													achieved this by sharing synthetic
													biology and arthropod-borne diseases
													with students aged three to eighteen
													during our outreach program, Dengue
													Day (Read more under Education-{'>'}
													Dengue Day).
												</li>
												<li>
													Convenience: He also suggested that
													we design our recombinant toxins,
													beetroot peel power, and Beeter Trap
													to be convenient, low-maintenance
													products that will appeal to a
													larger mass.
												</li>
												<li>
													Future of vector control: We also
													discussed the future of the use of
													recombinant larvicides in vector
													control, and he said we would need
													to do more in terms of synthetic
													biology education.
												</li>
												<li>
													Discuss further improvements to the
													appearance of our hardware
												</li>
											</ul>
										</ProfileView>
									</div>
									<div className='p-[5px] md:p-[50px]'>
										<ProfileView
											name={
												'Dr. Diana Rojas Alvarez, World Health Organization'
											}
											img={
												'https://static.igem.wiki/teams/5066/human-practice/diana.png'
											}
											date={'2024/08/30'}
											intro={
												'Dr. Diana is a medical doctor and an infectious diseases epidemiologist. She is also the team lead of Arboviruses EZD/WHE at the World Health Organization. The purpose of our interview was to gain feedback on our overall project and seek guidance on how we could promote our project on a broader, global scale through interacting with relevant NGOs. As a representative of the WHO, an international health organization, we believed she could advise us on strategies we could use to engage with organizations.  '
											}
										>
                                                <div className='mt-5 flex justify-center items-center'>
												<img
													src='https://static.igem.wiki/teams/5066/human-practice/dr-diana.png'
													className='w-[700px] h-auto'
													alt='meetPic'
												/>
											</div>
											<p className='p-[3px] md:p-[20px] mt-2 text-gray-700 font-bold'>
												Key Insights and Takeaways
											</p>
											<ul className='list-disc space-y-2 px-8 mb-4'>
												<li>
													The Pennytrap is extremely helpful for assisting underprivileged areas.
												</li>
												<li>
													Dr.Diana suggests we start in local communities and build up from there.
												</li>
												<li>
													Dr.Diana advises us to map out potential partners after proving our products’ efficacy and cost-effectiveness.
												</li>
												<li>
													Dr.Diana gave us an idea of how to prove effectiveness by telling us to find socioeconomically similar areas to test our product and use the data to prove it.
												</li>
												<li>
													Dr.Diana wants to make sure the community knows how to make Penny Traps so she suggests filming a video to guide the construction of the Penny Traps to enhance awareness of our sustainable alternative.
												</li>
												<li>
													Dr.Diana brought up the idea of letting kids bring recyclable items to make Penny Traps and this could raise awareness of our sustainable alternative and also can be distributed to households to prevent the spread of dengue fever.
												</li>
												<li>
													We could test its effectiveness by following the absenteeism from school due to dengue fever-related issues.
												</li>
												<li>
													Pitch idea to the TDR (a WHO developing program that funds projects)
												</li>
												<li>
													Be able to explain the sizing and overall function of our trap
												</li>
												<li>
													Ensuring that each decision we make for our hardware is thoughtful
												</li>
												<li>Conduct another survey about our product</li>
												<li>
													Connect with local NGOs first, before taking that progress to seek collaboration with international NGOs
												</li>
											</ul>
										</ProfileView>
									</div>
									<div className='p-[5px] md:p-[50px]'>
										<ProfileView
											name={'Taiwan Centers for Disease Control'}
											img={
												'https://static.igem.wiki/teams/5066/human-practice/cdc3.png'
											}
											intro={
												'Our team had the opportunity to speak with the Taiwan Centers for Disease Control (CDC) to better understand the current strategies for dengue prevention, the challenges faced, and potential areas for collaboration. This conversation allowed us to gain insights directly from the leading public health institution responsible for combating dengue fever in Taiwan.'
											}
										>   
                                        <div className='mt-5 flex justify-center items-center'>
												<img
													src='https://static.igem.wiki/teams/5066/human-practice/cdc.jpg'
													className='w-[700px] h-auto'
													alt='meetPic'
												/>
											</div>

											<p className='p-[3px] md:p-[20px] mt-2 text-gray-700 font-bold'>
												Key Insights and Takeaways
											</p>
											
											<div className='px-8 pb-8 text-gray-700'>
												<p className='p-[3px] md:p-[20px] text-gray-700'>
												Current Dengue Prevention Strategies:
												</p>
												<p className='p-[3px] md:p-[20px] text-gray-700'>
												The CDC highlighted several key measures for dengue prevention in Taiwan, especially from May to November, which include:
												</p>
	
												<ul className='list-disc pl-5 mb-4'>
													<li>
                                                    Educating the public on removing standing water that could serve as mosquito breeding grounds.
													</li>
													<li>
													Encouraging doctors to ask TOCC(Travel History, Occupation, Contact and Cluster) to diagnose potential dengue cases early. Infected individuals prompt immediate public health response, including area-based interventions.
													</li>
													<li>
													The use of Dengue NS1 rapid test to identify and test individuals for dengue at the earliest possible signs.
													</li>
													<li>
													Spraying insecticides and contacting medical professionals in areas with known dengue cases to ensure timely interventions.
													</li>
													<li>
													Tracking abroad cases of infected individuals and setting hot spots to prevent further spread of dengue fever. 
													</li>
												</ul>

												<p className='p-[3px] md:p-[20px] text-gray-700'>
												Technological Advances in Dengue Surveillance:
												</p>
												
												<ul className='list-disc pl-5 mb-4'>
													<li>
                                                    The CDC is using a dengue map to highlight and remind citizens of high-risk areas.
													</li>
													<li>
													They’ve also improved communication with healthcare professionals to ensure faster reporting and more proactive screening of patients for dengue.
													</li>
													<li>
													The CDC collaborates with National Mosquito-Borne Diseases Control Research Center and other cities, including Tainan and Kaohsiung, where innovative methods like ovitraps are being trialed for vector surveillance and control.
													</li>
												</ul>

												<p className='p-[3px] md:p-[20px] text-gray-700'>
												International Cooperation:
												</p>
												
												<ul className='list-disc pl-5 mb-4'>
													<li>
                                                    The CDC collaborates with various countries and international organizations, including Singapore and Japan to share data and strategies.
													</li>
													<li>
                                                    They also report in APEC and other international organizations to compare progress and gain insights from other countries’ dengue control efforts. This gives an understanding of how governments across the world are monitoring and controlling dengue fever. From this, we get an opportunity to collaborate with international governments and also implement our product.
													</li>
												</ul>


												<p className='p-[3px] md:p-[20px] text-gray-700'>
												Community Engagement:
												</p>
												
												<ul className='list-disc pl-5 mb-4'>
													<li>
														The CDC uses social media and
														posters to target the youth, and
														reports to target the elderly.
													</li>
													<li>
														High-risk places have
														significant public outreach to
														educate the community.
													</li>
													<li>
														Encouraging environmental
														cleaning by exchanging certain
														items with containers that can
														hold water.
													</li>
													<li>
														The CDC conducts tours to report
														on high-risk areas.
													</li>
												</ul>

												<p className='p-[3px] md:p-[20px] text-gray-700'>
												Insights/Suggestions:
												</p>
												
												<ul className='list-disc pl-5'>
													<li>
														Our ovitrap design aligns well
														with their prevention
														strategies, especially in
														regions with heavy rainfall.
													</li>
													<li>
														Community engagement and
														education are crucial,
														reinforcing our outreach to
														local schools and communities.
													</li>
													<li>
														Suggest collaborating with the
														National Mosquito-Borne Disease
														Control Research Center for
														ovitrap distribution in dengue
														hot spots.
													</li>
													<li>
														Localization of the project by
														adding local languages on social
														media and creating programs for
														interested groups.
													</li>
													<li>
														Enhance collaboration with
														high-risk areas like Kaohsiung
														to evaluate the impact of our
														traps and adjust based on
														feedback.
													</li>
												</ul>
											</div>
										</ProfileView>
									</div>
									<p className=' text-gray-700 font-bold'></p>
									<p className='p-[3px] md:p-[20px] text-gray-700'></p>
									<h1 className='text-xl mt-8 font-bold text-gray-700'>
										Summary
									</h1>
									<p className='text-gray-700 pt-4'>
										The social implementation phase emphasized
										integrating the sticky ovitrap project into
										communities worldwide to enhance public health
										and raise awareness of dengue prevention.Prof.
										Jason Wang highlighted the importance of
										lowering production costs to make the product
										accessible globally, inspiring the development
										of the Pennytrap for underprivileged areas.Dr.
										Gonçalo Martins Alves stressed the need for
										eco-friendly, reusable materials and convenience
										to ensure long-term utility and minimize waste,
										inspiring the idea of using beetroot peels from
										food waste and recycled plastics for building
										the Pennytrap.Dr.Diana Rojas Alvarez of the
										WHO provided a strategy for global outreach,
										advising an approach of starting with local
										communities, testing in socioeconomically
										similar areas, and engaging with NGOs to scale
										up.We contacted NGOs to put our
										product in action and to test it, knowing
										we had done many outreach with our local
										communities.Finally, Taiwan's CDC shared
										insights on existing dengue prevention measures
										and suggested aligning our product with their
										strategies, emphasizing community engagement and
										collaboration with high-risk areas.This
										motivated us to focus our efforts back into
										involving local schools and communities in our
										fight against dengue before anything else.These
										expert perspectives reinforce the importance of
										affordability, sustainability, and community
										involvement in the successful implementation of
										the project at both local and global levels.
									</p>
								</section>
							</div>
						</section>
					</div>

					<div className='pb-12'>
						<section id='s8'>
							<h2 className='text-3xl font-bold text-[#C94C67]'>
								Conclusion of IHP
							</h2>

							<p className='mt-2 text-gray-700'>
								The Integrated Human Practices (IHP) initiative has effectively engaged diverse stakeholders to enhance our dengue fever prevention and education efforts through a strategic outreach approach. We started by interviewing experts in entomology and public health to gather critical insights during the project definition and idea verification phases. This foundational knowledge was then complimented by extensive public surveys designed to assess community awareness and attitudes toward dengue. In the real-field implementation phase, we expanded our outreach to investors, bio-entrepreneurs, and company representatives, whose feedback helped us establish an effective business model. Finally, we consulted community engagement experts to ensure our educational initiatives would resonate with diverse populations. Our strategy not only enriched our project but also fostered broader support across sectors, positioning us to create effective, socially relevant solutions for dengue prevention.
							</p>
						</section>
					</div>
				</div>
			</div >
		</div >
	);
};

export default IHP;
